let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("afcFL"), load("ePOyH"), load("eacuJ")]).then(() => parcelRequire('bzo9I'));